/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { MessagesItemRequestBuilderRequestsMetadata, type MessagesItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /messages
 */
export interface MessagesRequestBuilder extends BaseRequestBuilder<MessagesRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.messages.item collection
     * @param id Unique identifier of the item
     * @returns {MessagesItemRequestBuilder}
     */
     byId(id: Guid) : MessagesItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const MessagesRequestBuilderUriTemplate = "{+baseurl}/messages";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const MessagesRequestBuilderNavigationMetadata: Record<Exclude<keyof MessagesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: MessagesItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["id"],
    },
};
/* tslint:enable */
/* eslint-enable */
